import { Component, OnInit, Input } from '@angular/core';
import { CourseService } from '../../../../services/course.service';
import { ViewUpdateService } from '../../../../services/view-update.service';
import { AddDataComponent } from '@scaffold/dialogs/add-data/add-data.component';
import { ItemsService } from '@scaffold/services/items.service';
import { ScaffoldDialogService, ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";

@Component({
  selector: 'app-listcard',
  templateUrl: './listcard.component.html',
  styleUrls: ['../../rendered.component.scss', './listcard.component.scss']
})
export class ListcardComponent implements OnInit {
  @Input() item;
  @Input() info;
  @Input() indexActive;
  // @Output() setDisplay = new EventEmitter<any>();
  view = [
  ];
  isActiveList = false;
  rootItem;
  item_data = [];
  active = -1;
  dialogRef: ScaffoldDialogRef;
  created = false;
  updateView = false;
  constructor(private courseService: CourseService,
    private viewUpdate: ViewUpdateService,
    public dialog: ScaffoldDialogService,
    private itemsService: ItemsService) { }

  ngOnInit() {
    if (!this.item.list_content) {
      this.getListItems();
    } else {
      if (this.item.list_content.listItems) {
        this.view = this.item.list_content.listItems;
      } else {
        this.view = [this.item.list_content];
      }
    }
    this.viewUpdate.registerListUpdate().subscribe(data => {
      let isType = false;
      // check if the list update was for the list type
      if (data && data.list_type === 'list') {
        // check if the list updated contains item of this type
        if (this.item.list_view.push) {
          this.item.list_view.forEach((type, i) => {
            if (type.name == data.type) {
              isType = true;
            }
          });
        } else {
          if (this.item.list_view == data.type) {
            isType = true;
          }
        }
        if (isType) {
          if (data.removed) {
            if (this.item && this.item.list_view) {
              let found = -1;
              this.view.forEach((v, i) => {
                if (v.id == data.removed) {
                  found = i;
                }
              });
              if (found >= 0) {
                this.view.splice(found, 1);
                this.getListItems();
              } else if (this.info.children) {
                this.courseService.get(this.info.type + '/' + this.info.id + '/' + this.item.type + '/' + this.item.id + '?mode=' + (this.item.list_mode || 'list'))
                  .subscribe(updated => this.info.children = updated);
              }
            }
          } else if (data.added) {
            if (this.info.id === data.parent_id) {
              this.getListItems();
            }
          } else {
            console.log('Preview Push');
            this.view.push(data.placeholder);
            // this.cdr.markForCheck();
            console.log(this.view);
          }
        }
      }

    });
  }

  // setDisplayItem(event, content) {
  //   event.stopPropagation();
  //   console.log(content);
  //   this.setDisplay.emit({ item: this.info, content: content, list: this });
  // }

  getListItems(isInitial?) {
    let query = '';
    let base = {};
    //   console.log(this.item.list_view);
    if (this.item.list_view.push) {
      base = this.item.list_view[0].name;

      if (this.item.list_view.length > 1) {
        query = '&additional=';
        this.item.list_view.forEach((v, i) => {
          if (i > 0) {
            query += v.name;
            if (i < this.item.list_view.length - 1) {
              query += ',';
            }

          }
        });
      }
    } else {
      base = this.item.list_view;
    }

    if (this.item.param && this.item.req_value) {
      query += '&searchParam=' + this.item.param + '&searchTerm=' + this.item.req_value;
    }
    let url;
    if (this.info) {
      if (this.info.type && this.info.id) {
        url = this.info.type + '/' + this.info.id + '/' + base;
      } else {
        url = '' + base;
      }
    }

    url += '?mode=' + (this.item.list_mode || 'list') + query;


    if (this.item.nested) {
      url += '&recursive=true';
    }
    this.courseService.get(url).subscribe(co => this.processItems(co, isInitial));

    return url;
  }

  createData(advSort?) {
    let createPosition;

    if (advSort) {
      createPosition = [advSort];
    } else if (this.item.param) {
      /*  let last = this.view[this.view.length - 1];

        createPosition = ["set_create_position=" + last.position + 1];*/
    }
    const type = this.item.list_view[0].name;
    const parent = this.info;
    const add = this.item.allow_add;
    console.log(parent);
    if (this.item.use_defaults) {
      //this.updateView;
      if (!this.created) {
        this.created = true;
        const default_data = {
          type: type,
          data: {}
        };
        this.item.new_defaults.forEach(def => {
          default_data.data[def.key] = def.value;
        });
        const path = this.info.type + '/' + this.info.id + '/' + type;
        const placeholder = ({
          type: type,
          title: default_data.data['title'] || type,
          data: {
            content: [{

              type: 'text',
              value: default_data.data['title'] || type
            }
            ]
          }
        });
        this.viewUpdate.triggerListChange({ 'list_type': 'list', placeholder: placeholder, 'type': type, parent_type: this.info.type, parent_id: this.info.id });
        this.itemsService.createData(path, default_data, createPosition).subscribe(d => {
          this.created = false;
          if (this.info) {
            this.viewUpdate.triggerListChange({ 'list_type': 'list', 'type': d.type, 'added': d.id, parent_type: this.info.type, parent_id: this.info.id });

          }

        });
      }
    } else {
      const data = {};
      if (this.item.param && this.item.req_value) {
        data[this.item.param] = this.item.req_value;
      }
      const settings: any = {
        context: {
          data: {
            comp: this,
            parent: parent,
            type: type,
            allowAdd: add,
            duplicate: null,
            data: data,
            urlParams: createPosition
          }
        }
      };
      this.dialogRef = this.dialog.open(AddDataComponent, settings);
      this.dialogRef.onClose.subscribe(result => {
        console.log(result);
        if (result && (result !== 'string' || result.length > 0)) {
          if (this.item.param) {
            this.info[this.item.param] = result.id;
          }

          if (this.item && this.item.list_view && this.item.type) {
            this.getListItems();
            // var query = "";
            // let base = {};
            // console.log(this.item.list_view);
            // if (this.item.list_view.push) {
            //     base = this.item.list_view[0].name
            //     if (this.item.list_view.length > 1) {
            //         query = '&additional=';
            //         this.item.list_view.forEach((v, i) => {
            //             if (i > 0) {
            //                 query += v.name
            //                 if (i < this.item.list_view.length - 1) {
            //                     query += ",";
            //                 }
            //             }
            //         })
            //     }
            // } else
            // base = this.item.list_view;
            // var url = "courses/" + this.courseService.id + "/" + base + "?mode=" + (this.item.list_mode || "list") + query
            // if (this.info) {
            //     var url = this.info.type + "/" + this.info.id + "/" + base + "?mode=" + (this.item.list_mode || "list") + query
            // }
            // this.courseService.get(url).subscribe(co => this.processItems(co));
          } else if (this.info.children) {
            this.courseService.get('courses/' + this.courseService.id + '/' + result.type + '/' + result.id + '?mode=' + (this.item.list_mode || 'list')).subscribe(updated => this.info.children = updated);

          }

        }
      });
    }
  }


  processItems(co, initial?) {
    let view = [];
    const existing = [];
    this.rootItem = this;
    const list_items = {

    };
    const allList = [];

    if (co && co.push) {

      co.listItems = co;
    }
    if (co && co.id) {

      co = { listItems: [co] };
    }
    //   list_items[this.courseService.id] = {};
    if (co && co.listItems) {
      if (co.listItems.push) {
        co.listItems.sort((a, b) => parseInt(a.position) - parseInt(b.position));

        co.listItems.forEach((v, i) => {
          if (v) {
            if (initial) {
              v.rootItem = this;
              v.rootView = this.item;
            } else {
              v.rootItem = this.info.rootItem;
              v.rootView = this.info.rootView;
            }
            list_items[v.id] = v;

          }
        });
        co.listItems.forEach((v, i) => {
          if (v && existing.indexOf(v.id) < 0) {
            existing.push(v.id);
            if (list_items[v.parent_id]) {
              /*  if (list_items[v.parent_id].type === 'moduleitems') {
                  list_items[v.parent_id].children = v;
              } else {*/
              if (!list_items[v.parent_id].childview) {
                list_items[v.parent_id].childview = [];
              }
              v.parent = list_items[v.parent_id];

              list_items[v.parent_id].childview.push(v);
              if (this.item.root_list) {
                allList.push(v);
              }
              // }
            } else {
              v.parent = this.info;
              if (!this.item.root_list) {
                view.push(v);
                this.item_data.push({});
              } else {
                allList.push(v);
              }
            }
          }
        });
        if (this.item.root_list) {
          view = allList.sort((a, b) => {
            let order = parseInt(a.position) - parseInt(b.position);
            if (order === 0) {
              if (a.id === b.parent_id) {
                order = -1;
              }
              if (b.id === a.parent_id) {
                order = 1;
              }
            }
            return order;
          });
        }
        //   console.log(this.view);
      } else {
        this.item_data.push({});
        view = [co.listItems];
      }
    } else {
      view = [];
    }
    this.view.length = 0;

    view.forEach(i => {

      this.view.push(i);
    });


    /*if (this.updateView) {
        this.setDisplayItem(this.view);
        this.updateView = false;
    }*/
    this.triggerUpdate();
  }



  triggerUpdate(e?) {
    // console.log(e);
    try {
      this.viewUpdate.triggerChangePropagation(e);
    } catch (e) {
      //  console.log(e)
    }
  }
}
